import { render, staticRenderFns } from "./c-widget@.vue?vue&type=template&id=f3dd65a0&scoped=true&"
import script from "./c-widget@.vue?vue&type=script&lang=ts&"
export * from "./c-widget@.vue?vue&type=script&lang=ts&"
import style0 from "./c-widget@.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./c-widget@.vue?vue&type=style&index=1&id=f3dd65a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3dd65a0",
  null
  
)

export default component.exports